import { useEffect } from 'react';

export const usePageBgGradient = (): void => {
  useEffect(() => {
    const gradient = document.getElementById('page-bg-gradient');
    const playground = document.getElementById('playground');
    const workflow = document.getElementById('how-it-works');
    if (!gradient || !playground || !workflow) return;

    let raf = 0;
    const update = () => {
      raf = 0;
      const vh = window.innerHeight;
      const pg = playground.getBoundingClientRect();
      const wf = workflow.getBoundingClientRect();

      if (pg.top >= vh || pg.bottom <= 0 || wf.bottom <= 0) {
        gradient.style.clipPath = 'inset(0 0 100% 0)';
        gradient.style.opacity = '0';
        return;
      }

      const clipTop = (Math.max(0, pg.top) / vh) * 100;
      gradient.style.clipPath = `inset(${clipTop.toFixed(2)}% 0 0 0)`;

      const fadeStart = vh;
      const fadeEnd = vh * 0.25;
      const opacity = Math.min(
        1,
        Math.max(0, (wf.top - fadeEnd) / (fadeStart - fadeEnd)),
      );
      gradient.style.opacity = opacity.toFixed(3);
    };

    const schedule = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    const ro = new ResizeObserver(schedule);
    ro.observe(playground);
    ro.observe(workflow);

    document.fonts?.ready.then(schedule).catch(() => undefined);

    update();

    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      ro.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);
};
